module.exports = __webpack_public_path__ + "static/img/gesture_control.ca63308.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/air_2020/gesture_control.png
// module id = AjUT
// module chunks = 1